import {Button, ButtonProps, useListContext, useNotify} from "react-admin";
import DescriptionIcon from "@material-ui/icons/Description";
import {clientNoJson} from "../../dataProvider";
import {useState} from "react";
import {url as URL} from "../../constants";
import {CircularProgress} from "@material-ui/core";
import {getFileNameFromContentDisposition} from "../../shared/utils";
import {BulkActionProps} from "ra-ui-materialui";

export interface Props{
    type: string;
    button_props?: ButtonProps;
}



export const PrintRibaPdfButton = (props: Props) => {
  const notify = useNotify();
  const [loading, setLoading] = useState(false);
  const { selectedIds, refetch,  } = useListContext();


  const handleSubmit = async (e: any) => {
    e.stopPropagation();
    setLoading(true);
    let res = null;

    try {
      res = await clientNoJson(`${URL}/bank_receipt/print_selected_bank_receipt_pdf/`, {
        method: "POST",
        data: { ids: selectedIds, type: props.type },
        responseType: "arraybuffer",
      });
    } catch (err: any) {
      notify("ra.message.error", "error");
      setLoading(false);
      return;
    }
    setLoading(false);
    const data = res.data; // or res.blob() if using blob responses

    const url = window.URL.createObjectURL(
      new Blob([data], {
        type: res.headers["content-type"],
      })
    );
    const actualFileName = getFileNameFromContentDisposition(
      res.headers["content-disposition"]
    );

    // uses the download attribute on a temporary anchor to trigger the browser
    // download behavior. if you need wider compatibility, you can replace this
    // part with a library such as filesaver.js
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", actualFileName);
    document.body.appendChild(link);
    link.click();
    if (link.parentNode) link.parentNode.removeChild(link);
    refetch();

  };

  return (
    <Button
      {...props.button_props}
      disabled={loading || selectedIds.length <= 0}
      label="Stampa Riba pdf"
      onClick={handleSubmit}
    >
      {loading ? <CircularProgress size={18} thickness={2} /> : <DescriptionIcon />}
    </Button>
  );
};
